/** Centered block-art logo for the first setup screen (above the intro panel). */
export const SETUP_INTRO_HEADER_ART: string[] = [
  "░█▀▀░█░█░█▀█░█▀▀░█▀▄░█▀█░█▀█░█░█░█▀█",
  "░▀▀█░█░█░█▀▀░█▀▀░█▀▄░█░█░█░█░▀▄▀░█▀█",
  "░▀▀▀░▀▀▀░▀░░░▀▀▀░▀░▀░▀░▀░▀▀▀░░▀░░▀░▀",
]

/**
 * Inner text column width for all setup frames: matches the first intro screen’s longest
 * unwrapped line (~94 chars) plus a small buffer for list markers and emoji width.
 * Update if intro copy in `prototyping/setup` changes. Still capped to the terminal in
 * `resolveFrameContentColumnWidth`.
 */
export const SETUP_INTRO_FRAME_INNER_WIDTH = 104

/** Centered art above the setup complete panel. */
export const SETUP_COMPLETE_FIREWORKS_ART: string[] = [
  "⠀⡀⠈⠀⢆⠀⠀⡆⠈⠀⠄⠀⢀⡀⠀⠀⡀⠐⠤⣈⣆⣧⡣⠔⠂⠐⠀⠀⠀⠀⠀⠀⠀⠠⠀⠈⠀⢀⠁⠀⠐⠀⠀⠀⠀⣀⠀⠀⠀⠈⠠⢌⡢⣀⣇⢔⡡⠄⠈⠀⠀⠀⠀⠀⠐⠀⠨⡀⠀⢰⠀⠀⠈⠀⠀",
  "⢀⠀⠤⢄⣈⣆⣸⣀⠤⠒⠀⠄⠀⠀⠀⠀⢀⡐⢒⡲⡧⣼⢖⡒⠒⠠⠀⠀⠀⠀⠈⠀⠂⠀⠢⡀⠀⢸⠀⢀⠔⠀⠁⠀⠀⠀⠀⠀⠀⠁⢀⡠⢜⠧⡼⡣⢄⡀⠐⠀⠀⠀⠂⠐⠀⣀⡀⠘⣄⣇⡠⠔⠁⠈⠀",
  "⢀⠀⠀⣀⠤⡧⢼⠦⢄⣀⠀⠄⠀⠀⠀⠀⠁⠈⠁⡰⠁⡇⢣⠈⢁⠀⠀⠀⠠⠄⠀⠠⠀⠀⠀⠈⢢⠼⡔⠁⠀⠀⠀⠁⠀⠀⠀⠀⠀⠊⠁⠠⠊⠀⡇⠑⠄⠀⠂⠀⣀⠀⠀⠐⠀⠀⢈⡩⢧⢼⠒⠢⠤⠀⠁",
  "⠀⢀⠉⠀⢠⠃⠈⢆⠀⠀⠠⠀⠀⠀⠂⠀⠀⠈⠀⠀⠄⠁⠠⠀⠀⠀⠀⠀⠀⠀⠀⢀⠀⠉⠉⢉⠝⢒⠫⡉⠉⠉⠁⠂⠀⠀⠀⠀⠀⠀⠈⠀⠠⠀⠁⠄⠀⠁⠀⠀⠀⠀⠀⠀⠀⠂⠐⠁⠀⡜⠀⠣⡀⠀⠀⠁",
  "⠀⠀⠀⠄⠈⡀⠀⡈⠀⠂⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⢀⠉⠔⠁⠀⢸⠀⠈⠢⠀⠠⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠐⠂⠀⡀⠁⡀⠀⠄⠀⠁⠀",
]

export const SETUP_DOCS_URL = "https://developers.supernova.io/cli-prototyping-setup"
export const ANALYZER_DOCS_URL = "https://developers.supernova.io/cli-analyze"
export const TEMP_NPMRC_MARKER = ".supernova-setup-temp-npmrc"
// Placeholder resolved by npm when NPM_TOKEN is provided in the environment.
// eslint-disable-next-line no-template-curly-in-string
export const NPM_TOKEN_NPMRC_LINE = "//registry.npmjs.org/:_authToken=${NPM_TOKEN}"

export const PRIVATE_DEPENDENCIES_DOCS_URL =
  "https://developers.supernova.io/latest/supernova-create/set-up-code-libraries/guided-container-setup-Kh7LnoyQ#section-if-your-packages-are-private-74"
